import { get, getAssert, getElse } from "../../utils/Safe";

/**
 * TODO - Add description.
 */
export default class FlumpKeyframeSymbol
{
    /**
     * @param {*} json - JSON object for the keyframe.
     * @param {FlumpKeyframeSymbol} prevKf - Previous keyframe for parent layer.
     */
    constructor(json, prevKf)
    {
        /** @type {number} */
        this.index = (prevKf != null) ? prevKf.index + prevKf.duration : 0;
        
        /** @type {number} */
        this.duration = get([json, "duration"]);
        /** @type {string} */
        this.symbolName = get([json, "ref"]);
        /** @type {string} */
        this.label = get([json, "label"]);
        
        // Safely get these properties from the json.
        let loc = getElse([json, "loc"], [0, 0]);
        let scale = getElse([json, "scale"], [1, 1]);
        let skew = getElse([json, "skew"], [0, 0]);
        let pivot = getElse([json, "pivot"], [0, 0]);

        /** @type {number} */
        this.x = loc[0];
        /** @type {number} */
        this.y = loc[1];
        /** @type {number} */
        this.scaleX = scale[0];
        /** @type {number} */
        this.scaleY = scale[1];   
        /** @type {number} */     
        this.skewX = skew[0];
        /** @type {number} */
        this.skewY = skew[1];
        /** @type {number} */
        this.pivotX = pivot[0];
        /** @type {number} */
        this.pivotY = pivot[1];
        /** @type {number} */
        this.alpha = getElse([json, "alpha"], 1);
        /** @type {number} */
        this.ease = getElse([json, "ease"], 0);
        /** @type {boolean} */
        this.visible = getElse([json, "visible"], true);
        /** @type {boolean} */
        this.tweened = getElse([json, "tweened"], true);
    }
}